<template>
  <div class="el-upload">
    <el-form>
      <draggable
        @start="start"
        @end="end"
        v-model="fileList"
        style="display: flex; flex-wrap: wrap"
      >
        <!-- 拖拽元素 -->
        <div
          class="itemI"
          v-for="(item, index) in fileList"
          :key="item + index"
        >
          <el-image
            @click="handlePictureCardPreview(item)"
            style="width: 108px; height: 108px; border-radius: 6px"
            :src="item.url"
          ></el-image>
          <span
            v-if="index == 0 && isCustomer == 0"
            style="color: #2d46ee; position: absolute; top: 100px; left: 10px"
            >（商品主图）</span
          >
          <div @click="handleRemove(item, index)" class="close">
            <i class="el-icon-close" style="color: #2d46ee"></i>
          </div>
          <!-- <i
            @click="handleRemove(item, index)"
            class="el-icon-circle-close"
            style="
              color: #2d46ee;
              font-size: 20px;
              border-radius: 100%;
              width: 16px;
              height: 16px;
              background-color: white;
              position: absolute;
              top: -8px;
              right: -4px;
              z-index: 999;
            "
          ></i> -->
          <!-- <div class="mark" v-if="isMark && indexM == index">
            <i
              @click="handlePictureCardPreview(item)"
              class="el-icon-zoom-in"
              style="color: white; font-size: 20px; margin-right: 10px"
            ></i>
            <i
              @click="handleRemove(item, index)"
              class="el-icon-delete"
              style="color: white; font-size: 20px"
            ></i>
          </div> -->
        </div>
        <el-upload
          style="margin-bottom: 7px"
          :limit="limit"
          action=""
          accept="image/*"
          :http-request="uploadFile"
          list-type="picture-card"
          :auto-upload="true"
          :file-list="fileList"
          :on-preview="handlePictureCardPreview"
          :on-exceed="handleExceed"
          :show-file-list="false"
          multiple
          ref="upload"
        >
          <i class="el-icon-plus avatar-uploader-icon"></i>
          <!--        <img src="https://img-home.csdnimg.cn/images/20201124032511.png" width="146" height="146">-->
        </el-upload>
      </draggable>
      <!-- 上传按钮 -->
      <el-dialog :visible.sync="dialogVisible" append-to-body>
        <img width="100%" fit="contain" :src="dialogImageUrl" alt="" />
      </el-dialog>
    </el-form>
  </div>
</template>
<script>
import draggable from 'vuedraggable'
export default {
  components: {
    draggable
  },
  props: {
    limit: {
      type: Number,
      default: 6
    },
    isCustomer: {
      type: Number,
      default: 0
    },
    list: {
      type: Array,
      default: () => []
    },
    showAddIcon: {
      type: Boolean,
      default: true
    }
  },
  watch: {
    list (val, vall) {
      console.log(val)
      // val.forEach(item => {
      //   let str = this.ImgHttps + item.url
      //   Object.assign(item, { url: str })
      // });
      this.fileList = val

    }
  },
  data () {
    return {
      imageUrl: '',
      dialogImageUrl: '',
      dialogVisible: false,
      isMark: false,
      indexM: null,
      fileList: []
    }
  },
  methods: {
    mouseenter (e, index) {
      this.indexM = index
      this.isMark = true
    },
    mouseleave () {
      this.isMark = false
    },
    start (e) {
    },
    end (e) {
      this.$emit('changeImage', this.fileList)
    },
    submitUpload () { this.$refs.upload.submit() },
    uploadFile (e) {
      console.log(e, '5555')
      const file = e.file
      const size = file.size / 1024 / 1024
      console.log(size)
      if (!(file.type === 'image/png' || file.type === 'image/jpg' || file.type === 'image/jpeg' || file.type === 'image/gif')) {
        this.$message.error('请上传格式为png、jpg、jpeg、gif的图片')
        return
      } else if (size > 5) {
        this.$message.error('图片大小必须小于5M')
        // this.$notify.warning({
        //   title: '警告',
        //   message: '图片大小必须小于2M'
        // })
        return
      } else {
        const params = new FormData()
        params.append('file', file) // 图片
        console.log(params)
        this.$api.uploadFiles(params).then(res => {
          if (res.code === 0) {
            this.$message.success('上传成功')
            this.imageUrl = this.ImgHttps + res.data.url
            const obj = {
              url: this.imageUrl,
              mainFlag: false
            }
            this.fileList.push(obj)
            this.$emit('changeImage', this.fileList)
          } else {
            this.$message.error('上传失败')
          }
        })
      }
    },
    // 图片上传超过数量限制
    handleExceed (files, fileList) {
      this.$message.error('图片数量超出限制!')
      console.log(files, fileList)
    },
    // 删除图片
    handleRemove (file, index) {
      this.fileList.splice(index, 1)
    },
    // 预览图片
    handlePictureCardPreview (file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep .el-upload--picture-card {
  width: 108px;
  height: 108px;
  cursor: pointer;
  line-height: 108px;
}
.close {
  width: 16px;
  height: 16px;
  background: #ffffff;
  border: 1px solid #2d46ee;
  border-radius: 50%;
  opacity: 1;
  position: absolute;
  top: -8px;
  right: -4px;
  z-index: 999;
  text-align: center;
  line-height: 16px;
  font-weight: 800;
}
.el-dialog .el-dialog__header {
  border-bottom: none;
}
.itemI {
  width: 108px;
  height: 108px;
  border-radius: 6px;
  margin-right: 18px;
  border: 1px dashed #d9d9d9;
  position: relative;
  margin-bottom: 7px;
  .image {
    position: absolute;
    left: 0;
    top: 0;
    width: 108px;
    height: 108px;
    border-radius: 6px;
    z-index: 1;
  }
  .mark {
    position: absolute;
    left: 0;
    top: 0;
    width: 108px;
    height: 108px;
    border-radius: 6px;
    line-height: 108px;
    z-index: 2;
    background-color: rgba(0, 0, 0, 0.5);
  }
}
// .item:hover {
//   opacity: 0.5;
// }
</style>
